import * as React from 'react';
import { PopupInnerRef, PopupProps } from '../types';
import PopupInner from './PopupInner';

const Popup = React.forwardRef<PopupInnerRef, PopupProps>(
  (props, ref) => {
		return (
			<PopupInner weId={`${props.weId || ''}_lumem0`} {...props} ref={ref} />
		)
	}
);


Popup.displayName = 'Popup';

export default Popup;